var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "terms-outline" },
    [
      _c("p", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.content.header[0].content)),
      ]),
      _vm._v(" "),
      _c("Depth2Content", { attrs: { content: _vm.content } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }